import React, { useEffect, useRef, useState } from 'react'
import { withAuth } from '../AuthContext'
import { gaEvents } from '../../analytics/events'
import { Link, withRouter } from 'react-router-dom'
import { getCurrencySign, shouldTranslateTo } from '../../utils/utils'
import { ActionButtons, Subtitle, Title } from '../Utils/CustomClasses'
import styled from 'styled-components'
import Cookies from 'universal-cookie'
import MyFreebirdDashboard from './MyFreebirdDashboard'
import MyFreebirdPopup from './MyFreebirdPopup'
import MyFreebirdOnboarding from './MyFreebirdOnboarding'
import MyFreebirdOpacityScreen from './MyFreebirdOpacityScreen'
import MyFreebirdProfilePanel from './MyFreebirdProfilePanel'
import MyFreebirdNavBar from './MyFreebirdNavBar'
import MyFreebirdDiscountPopup from './MyFreebirdDiscountPopup'
import MyFreebirdOpacityDiscountScreen from './MyFreebirdOpacityDiscountScreen'
import { scrollIntoView } from '../Hooks/ScrollView'

const queryParams = new URLSearchParams(window.location.search)
const cookies = new Cookies()

const MyFreebirdSection = styled.section`
  background-color: #fff;
`

const TopSectionContainer = styled.div``

const MainSectionContainer = styled.div`
  position: relative;
`

const FlexRowProgress = styled.div`
  background-color: #154549;
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: stretch;
  position: relative;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }

  @media screen and (min-width: 800px) {
    min-height: ${(props) => (props.minheight ? props.minheight : 'auto')};
  }
`

const TaskListBoxContainer = styled.div`
  width: 40%;
  position: relative;

  @media screen and (max-width: 799px) {
    background-color: #154549;
    height: 390px;
    width: 100%;
  }
`

const TaskListBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  padding: 20px 20px 50px;
  position: absolute;
  top: 30px;
  right: 50px;
  z-index: 100;

  width: 30%;
  min-width: 280px;

  @media screen and (max-width: 499px) {
    width: 80%;
    top: 0;
    left: 10%;
    right: 10%;
    min-width: 200px;
  }

  @media screen and (min-width: 500px) and (max-width: 799px) {
    width: 60%;
    top: 0;
    left: 20%;
    right: 20%;
    min-width: 200px;
  }
`

const SplitRow = styled.div`
  display: flex;
  justify-content: space-between;

  & > div {
    flex-basis: 50%;
  }
`

const SplitColumn = styled.div``

const SplitColumnRight = styled(SplitColumn)`
  text-align: right;

  span {
    font-size: 18px;
  }
`

const ProgressBar = styled.div`
  background-color: #ababab;
  border-radius: 4px;
  margin: 4px 0 0 0;
  overflow: hidden;
  width: 100%;
`

const Progress = styled.div`
  background-color: #0bac5d;
  height: 8px;
  width: ${(props) => (props.width ? props.width : '0%')};
`

const TaskTitleBox = styled.div`
  border-bottom: 3px solid #ababab;
  display: flex;
  justify-content: space-between;
  margin: 30px 0 0 0;
`

const TaskTitleBoxLeft = styled.div`
  width: -webkit-fill-available;
`

const TaskTitleBoxRight = styled.div`
  text-align: right;
  width: 60px;
`

const InfoImage = styled.img`
  margin: 0 0 2px 0;
  width: 16px;
`

const TaskListItemLink = styled(Link)`
  text-decoration: none;

  & hover {
    text-decoration: underline;
  }
`

const TaskListItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 14px 0 0 0;
`

const TaskListItemLeft = styled.div`
  width: 43px;
`

const TaskListItemMiddle = styled.div`
  width: -webkit-fill-available;
`

const TaskListItemRight = styled.div`
  text-align: right;
  width: 40px;
`

const CbImage = styled.img`
  width: 20px;
`

const ChevronImage = styled.img`
  width: 18px;
`

const PromoPanelMobileWrapper = styled.div`
  display: block;
  width: -webkit-fill-available;

  @media (min-width: 800px) {
    display: none;
  }
`

const PromoPanelLaptopWrapper = styled.div`
  display: block;
  width: -webkit-fill-available;

  @media (max-width: 799px) {
    display: none;
  }
`

const PromoPanelBox = styled.div`
  height: 100%;
  width: 100%;
`

const PromoPanelBody = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 120px 50px 20px;

  @media screen and (max-width: 799px) {
    padding: 20px 10% 0;
  }

  @media screen and (min-width: 800px) {
    min-height: 340px;
  }
`

const PromoText = styled.div`
  width: 100%;
  text-align: left;

  & > button {
    margin: 45px 20px 40px;
  }

  @media screen and (max-width: 799px) {
    text-align: center;
  }
`

const ActionButtonMyFreebird = styled(ActionButtons)`
  background-color: #0bac5d;

  @media screen and (max-width: 799px) {
    width: -webkit-fill-available;
  }

  @media screen and (min-width: 800px) {
    min-width: 370px;
  }
`

const ShareASaleIFrame = styled.div`
  visibility: visible;
  height: 100px;
`

const OnboardingWrapper = styled.div``

const MyFreebird = (props) => {
  const [pageText, setPageText] = useState([])
  const [user, setUser] = useState([])
  const [country, setCountry] = useState('')
  const [countriesNice, setCountriesNice] = useState([])
  const [currencySign, setCurrencySign] = useState('')
  const [accountProgress, setAccountProgress] = useState('0')
  const [accountStatus, setAccountStatus] = useState(props.auth.user.status)
  const [profilePicState, setProfilePicState] = useState('pending')
  const [emailState, setEmailState] = useState('pending')
  const [profileInfoState, setProfileInfoState] = useState('pending')
  const [contributionState, setContributionState] = useState('pending')
  const [idState, setIdState] = useState('pending')
  const [phoneState, setPhoneState] = useState('pending')
  const [showStepFromQueryString, setShowStepFromQueryString] = useState('')
  const [chosenStep, setChosenStep] = useState('')
  const [promoPanelStep, setPromoPanelStep] = useState('')
  const [onboardingOpen, setOnboardingOpen] = useState(false)
  const [isIntersecting, setIsIntersecting] = useState(false)
  const [progressDelay, setProgressDelay] = useState(0)
  const [stage1Achieved, setStage1Achieved] = useState(false)
  const [profileEnhanced, setProfileEnhanced] = useState(false)
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [clickedFeeLink, setClickedFeeLink] = useState(false)
  const [discountCode, setDiscountCode] = useState('FREEB10125')
  const [isCopied, setIsCopied] = useState(false)
  const actionRef = useRef(null)
  const [iAminSubscriptionFormPanel, setIAminSubscriptionFormPanel] =
    useState(false)
  const [isCopiedInSubFormPanel, setIsCopiedInSubFormPanel] = useState(false)

  const progressSteps = {
    photo: 'photo',
    email: 'email',
    emailconf: 'emailconf',
    profile: 'profile',
    profilestage2: 'profilestage2',
    fee: 'fee',
    feestage2: 'feestage2',
    phone: 'phone',
    id: 'id',
    community: 'community',
  }

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        props.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    getPageText('profile-app', language)
    getCurrency()

    setInterval(() => {
      if (props.auth.user.emailStatus === 'pending') {
        axios
          .get('/api/user/email-status')
          .then((response) => {
            if (response.data.emailStatus === 'verified') {
              const userData = {
                emailStatus: response.data.emailStatus,
              }
              props.auth.updateUser(userData)
              calculateAccountProgressAndHiglighting()
            }
          })
          .catch(function (error) {
            console.log('Email status failure: ', error)
          })
      }
    }, 8000)
  }, [])

  useEffect(() => {
    if (props.auth.user.countryId && country.length <= 1) {
      axios
        .get('/api/countries-list')
        .then((response) => {
          const countriesNiceList = response.data.map((item) => {
            return { value: item.id, label: item.nicename }
          })
          const country = countriesNiceList.find(
            (c) => c.value === props.auth.user.countryId
          )
          setCountriesNice(countriesNiceList)
          setCountry(country.label)
        })
        .catch(function (error) {
          console.log('Request failure: ', error)
        })
    }
  }, [props.auth.user])

  useEffect(() => {
    var favsCountTally = 0
    var philosophyAdded = props.auth.user.philosophy ? true : false
    var favoPlaceAdded = props.auth.user.favoPlace ? true : false
    var favoVisitedPlaceAdded = props.auth.user.favoVisitedPlace ? true : false

    props.auth.user.favoBook && favsCountTally++
    props.auth.user.favoFilm && favsCountTally++
    props.auth.user.favoActor && favsCountTally++
    props.auth.user.favoMusician && favsCountTally++
    props.auth.user.favoFood && favsCountTally++
    props.auth.user.favoExercise && favsCountTally++
    props.auth.user.favoHero && favsCountTally++

    if (
      philosophyAdded &&
      favoPlaceAdded &&
      favoVisitedPlaceAdded &&
      favsCountTally >= 3
    ) {
      setProfileEnhanced(true)
    } else {
      setProfileEnhanced(false)
    }
  }, [props.auth.user])

  useEffect(() => {
    calculateAccountProgressAndHiglighting()
    props.auth.user.status === 'registered' && setProgressDelay(600)
  }, [pageText])

  /**
   *
   *  for back button
   *  check the storage if its true show popup
   *  the remove from storage
   */
  useEffect(() => {
    if (
      localStorage.getItem('clickedFeeLink') === 'true' &&
      props.auth.user.membershipFeeStatus !== 'completed'
    ) {
      console.log('>>>> pop up triggered from back button...')

      //
      // console.log('Popup should be visible now');
      setClickedFeeLink(true)
      setIsPopupVisible(true)
      localStorage.removeItem('clickedFeeLink')
    } else {
      // console.log('Popup should not be visible');
    }
  }, [])

  const calculateAccountProgressAndHiglighting = () => {
    setOnboardingOpen(false)

    setTimeout(function () {
      axios
        .get('/api/verify-account-status/myfreebird')
        .then((response) => {
          const userData = {
            status: response.data.status,
          }
          props.auth.updateUser(userData)
          setUser(props.auth.user)
        })
        .catch((err) => {
          console.log('Error getting account status: ', err)
        })

      var taskTally = 0
      var approvedTaskTally = 0
      var nextItemHighlighted = false

      if (props.auth.user.profilePhotoStatus === 'completed') {
        setProfilePicState('completed')
        taskTally += 1
      } else {
        setProfilePicState('current')
        setPromoPanelStep(progressSteps.photo)
        setChosenStep(progressSteps.photo)
        nextItemHighlighted = true
      }

      if (props.auth.user.emailStatus === 'verified') {
        setEmailState('completed')
        taskTally += 1
      } else {
        if (nextItemHighlighted === false) {
          setEmailState('current')
          setPromoPanelStep(progressSteps.email)
          setChosenStep(progressSteps.email)
          nextItemHighlighted = true
        } else {
          setEmailState('standard')
        }
      }

      if (props.auth.user.introductionStatus === 'completed') {
        setProfileInfoState('completed')
        taskTally += 1
      } else {
        if (nextItemHighlighted === false) {
          setProfileInfoState('current')
          setPromoPanelStep(progressSteps.profile)
          setChosenStep(progressSteps.profile)
          nextItemHighlighted = true
        } else {
          setProfileInfoState('standard')
        }
      }

      if (props.auth.user.membershipFeeStatus === 'completed') {
        setContributionState('completed')
        taskTally += 1
      } else {
        if (nextItemHighlighted === false) {
          setContributionState('current')
          setPromoPanelStep(progressSteps.fee)
          setChosenStep(progressSteps.fee)
          nextItemHighlighted = true
        } else {
          setContributionState('standard')
        }
      }

      if (taskTally === 4) {
        setStage1Achieved(true)
      } else {
        setStage1Achieved(false)
      }

      // Show verify account task box once stage 1 approval steps are completed
      if (
        props.auth.user.profilePhotoStatus === 'completed' &&
        props.auth.user.emailStatus === 'verified' &&
        props.auth.user.introductionStatus === 'completed' &&
        props.auth.user.membershipFeeStatus === 'completed'
      ) {
        props.auth.user.status === 'registered' &&
          setAccountStatus('partiallycompleted')

        if (props.auth.user.proofIdentityStatus === 'completed') {
          setIdState('completed')
          approvedTaskTally += 1
        } else {
          if (nextItemHighlighted === false) {
            setIdState('current')
            setPromoPanelStep(progressSteps.id)
            setChosenStep(progressSteps.id)
            nextItemHighlighted = true
          } else {
            setIdState('standard')
          }
        }

        if (props.auth.user.phoneStatus === 'verified') {
          setPhoneState('completed')
          approvedTaskTally += 1
        } else {
          if (nextItemHighlighted === false) {
            setPhoneState('current')
            setPromoPanelStep(progressSteps.phone)
            setChosenStep(progressSteps.phone)
            nextItemHighlighted = true
          } else {
            setPhoneState('standard')
          }
        }

        setAccountProgress(Math.round((approvedTaskTally / 2) * 100))
      } else {
        setAccountProgress(Math.round((taskTally / 4) * 100))
      }

      // Catch-all as all items have been completed
      if (nextItemHighlighted === false) {
        setPromoPanelStep(progressSteps.profilestage2)
        setChosenStep(progressSteps.profilestage2)
        nextItemHighlighted = true
      }

      if (showStepFromQueryString) {
        setChosenStep(showStepFromQueryString)
      }

      if (queryParams.get('pfs')) {
        console.log('pfs: ' + queryParams.get('pfs'))
        setShowStepFromQueryString(queryParams.get('pfs'))
        handleQueryStringStep(queryParams.get('pfs'))
      }
    }, progressDelay)
  }

  const panelHasUpdated = () => {
    setProgressDelay(600)
    calculateAccountProgressAndHiglighting()
  }

  const setPopupClosed = () => {
    setIsIntersecting(false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handlePromoPanelClick = (e) => {
    e.preventDefault()
    handleOpenPanel(promoPanelStep)
  }

  const handleTaskItemClick = (e, item) => {
    e.preventDefault()
    handleOpenPanel(item)
  }

  const handleQueryStringStep = (item) => {
    console.log('handleQueryStringStep...')
    handleOpenPanel(item)
  }

  const handleOpenPanel = (item) => {
    console.log('handleOpenPanel...')
    /*
       checking if its fee
       also setting link to fill in the text
       localstorage to temp persist for the back
    */
    if (item === 'fee') {
      setClickedFeeLink(true)
      localStorage.setItem('clickedFeeLink', true)
    }
    if (chosenStep === item) {
      console.log('1...')
      onboardingOpen === false && setOnboardingOpen(true)
    } else {
      console.log('2...')
      if (!onboardingOpen) {
        console.log('3...')
        setChosenStep(item)
        setOnboardingOpen(true)
      } else {
        console.log('4...')
        setChosenStep(item)
      }
    }
    // scroll into view
    setTimeout(function () {
      scrollIntoView(actionRef)
    }, 1000)
  }

  const closeOnboardingPanel = (e) => {
    // this is the close red icon, which shows bailing
    // back
    e.preventDefault()
    setOnboardingOpen(false)
    if (clickedFeeLink === true && user.membershipFeeStatus !== 'completed') {
      console.log('trigger pop-up from exit button...')
      setIsPopupVisible(true)
    }
  }

  const TaskList = () => {
    return (
      <TaskListBoxContainer>
        <TaskListBox>
          {/* Header */}
          <SplitRow>
            <SplitColumn>
              <Title
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="105%"
                weight="700"
                margin="0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[0]}`,
                }}
              ></Title>
            </SplitColumn>
            <SplitColumnRight>
              {' '}
              <Title
                color="#0bac5d"
                size="44px"
                sizemd="44px"
                sizesm="44px"
                lineheight="100%"
                weight="700"
                margin="-5px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${accountProgress}<span>%</span>`,
                }}
              ></Title>
            </SplitColumnRight>
          </SplitRow>
          {/* Account progress */}
          <ProgressBar>
            <Progress width={`${accountProgress}%`}></Progress>
          </ProgressBar>
          {/* Compulsory task list */}
          <TaskTitleBox>
            <TaskTitleBoxLeft>
              <Subtitle
                color="#818181"
                size="17px"
                sizemd="17px"
                sizesm="17px"
                lineheight="100%"
                weight="700"
                margin="0 0 4px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[1]}`,
                }}
              />
            </TaskTitleBoxLeft>
            <TaskTitleBoxRight>
              {' '}
              {/*
                        <Link>
                            <InfoImage
                                src={"/images/profile/icon-info.svg"}
                                alt={"info"}
                            />
                        </Link>
                        */}
            </TaskTitleBoxRight>
          </TaskTitleBox>
          <TaskListItemLink
            to=""
            onClick={(e) => handleTaskItemClick(e, progressSteps.photo)}
          >
            <TaskListItem>
              <TaskListItemLeft>
                <CbImage
                  src={`/images/profile/icon-cb-${profilePicState}.svg`}
                  alt={'checkbox'}
                />
              </TaskListItemLeft>
              <TaskListItemMiddle>
                <Subtitle
                  color="#000"
                  size="17px"
                  sizemd="17px"
                  sizesm="17px"
                  lineheight="100%"
                  weight="400"
                  margin="1px 0 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[2]}`,
                  }}
                />
              </TaskListItemMiddle>
              <TaskListItemRight>
                <ChevronImage
                  src={`/images/profile/icon-cv-${profilePicState}.svg`}
                  alt={'info'}
                />
              </TaskListItemRight>
            </TaskListItem>
          </TaskListItemLink>
          <TaskListItemLink
            to=""
            onClick={(e) => handleTaskItemClick(e, progressSteps.email)}
          >
            <TaskListItem>
              <TaskListItemLeft>
                <CbImage
                  src={`/images/profile/icon-cb-${emailState}.svg`}
                  alt={'checkbox'}
                />
              </TaskListItemLeft>
              <TaskListItemMiddle>
                <Subtitle
                  color="#000"
                  size="17px"
                  sizemd="17px"
                  sizesm="17px"
                  lineheight="100%"
                  weight="400"
                  margin="1px 0 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[3]}`,
                  }}
                />
              </TaskListItemMiddle>
              <TaskListItemRight>
                <ChevronImage
                  src={`/images/profile/icon-cv-${emailState}.svg`}
                  alt={'info'}
                />
              </TaskListItemRight>
            </TaskListItem>
          </TaskListItemLink>
          <TaskListItemLink
            to=""
            onClick={
              props.auth.user.profilePhotoStatus === 'completed' &&
              props.auth.user.emailStatus === 'verified' &&
              props.auth.user.introductionStatus === 'completed' &&
              props.auth.user.membershipFeeStatus === 'completed'
                ? (e) => handleTaskItemClick(e, progressSteps.profilestage2)
                : (e) => handleTaskItemClick(e, progressSteps.profile)
            }
          >
            <TaskListItem>
              <TaskListItemLeft>
                <CbImage
                  src={`/images/profile/icon-cb-${profileInfoState}.svg`}
                  alt={'checkbox'}
                />
              </TaskListItemLeft>
              <TaskListItemMiddle>
                <Subtitle
                  color="#000"
                  size="17px"
                  sizemd="17px"
                  sizesm="17px"
                  lineheight="100%"
                  weight="400"
                  margin="1px 0 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[4]}`,
                  }}
                />
              </TaskListItemMiddle>
              <TaskListItemRight>
                <ChevronImage
                  src={`/images/profile/icon-cv-${profileInfoState}.svg`}
                  alt={'info'}
                />
              </TaskListItemRight>
            </TaskListItem>
          </TaskListItemLink>
          <TaskListItemLink
            to=""
            onClick={(e) => handleTaskItemClick(e, progressSteps.fee)}
          >
            <TaskListItem>
              <TaskListItemLeft>
                <CbImage
                  src={`/images/profile/icon-cb-${contributionState}.svg`}
                  alt={'checkbox'}
                />
              </TaskListItemLeft>
              <TaskListItemMiddle>
                <Subtitle
                  color="#000"
                  size="17px"
                  sizemd="17px"
                  sizesm="17px"
                  lineheight="100%"
                  weight="400"
                  margin="1px 0 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[5]}`,
                  }}
                />
              </TaskListItemMiddle>
              <TaskListItemRight>
                <ChevronImage
                  src={`/images/profile/icon-cv-${contributionState}.svg`}
                  alt={'info'}
                />
              </TaskListItemRight>
            </TaskListItem>
          </TaskListItemLink>
        </TaskListBox>
      </TaskListBoxContainer>
    )
  }

  const TaskListApproved = () => {
    if (promoPanelStep !== progressSteps.profilestage2) {
      return (
        <TaskListBoxContainer>
          <TaskListBox>
            {/* Header */}
            <SplitRow>
              <SplitColumn>
                <Title
                  size="17px"
                  sizemd="17px"
                  sizesm="17px"
                  lineheight="105%"
                  weight="700"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[44]}`,
                  }}
                ></Title>
              </SplitColumn>
              <SplitColumnRight>
                {' '}
                <Title
                  color="#0bac5d"
                  size="44px"
                  sizemd="44px"
                  sizesm="44px"
                  lineheight="100%"
                  weight="700"
                  margin="-5px 0 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `${accountProgress}<span>%</span>`,
                  }}
                ></Title>
              </SplitColumnRight>
            </SplitRow>
            {/* Account progress */}
            <ProgressBar>
              <Progress width={`${accountProgress}%`}></Progress>
            </ProgressBar>
            {/* Verified task list */}
            <TaskTitleBox>
              <TaskTitleBoxLeft>
                <Subtitle
                  color="#818181"
                  size="17px"
                  sizemd="17px"
                  sizesm="17px"
                  lineheight="100%"
                  weight="700"
                  margin="0 0 4px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[6]}`,
                  }}
                />
              </TaskTitleBoxLeft>
              <TaskTitleBoxRight>
                {' '}
                {/*
                          <Link>
                              <InfoImage
                                  src={"/images/profile/icon-info.svg"}
                                  alt={"info"}
                              />
                          </Link>
                          */}
              </TaskTitleBoxRight>
            </TaskTitleBox>
            <TaskListItemLink
              onClick={(e) => handleTaskItemClick(e, progressSteps.id)}
            >
              <TaskListItem>
                <TaskListItemLeft>
                  <CbImage
                    src={`/images/profile/icon-cb-${idState}.svg`}
                    alt={'checkbox'}
                  />
                </TaskListItemLeft>
                <TaskListItemMiddle>
                  <Subtitle
                    color="#000"
                    size="17px"
                    sizemd="17px"
                    sizesm="17px"
                    lineheight="100%"
                    weight="400"
                    margin="1px 0 0 0"
                    dangerouslySetInnerHTML={{
                      __html: `${pageText[8]}`,
                    }}
                  />
                </TaskListItemMiddle>
                <TaskListItemRight>
                  <ChevronImage
                    src={`/images/profile/icon-cv-${idState}.svg`}
                    alt={'info'}
                  />
                </TaskListItemRight>
              </TaskListItem>
            </TaskListItemLink>
            <TaskListItemLink
              onClick={(e) => handleTaskItemClick(e, progressSteps.phone)}
            >
              <TaskListItem>
                <TaskListItemLeft>
                  <CbImage
                    src={`/images/profile/icon-cb-${phoneState}.svg`}
                    alt={'checkbox'}
                  />
                </TaskListItemLeft>
                <TaskListItemMiddle>
                  <Subtitle
                    color="#000"
                    size="17px"
                    sizemd="17px"
                    sizesm="17px"
                    lineheight="100%"
                    weight="400"
                    margin="1px 0 0 0"
                    dangerouslySetInnerHTML={{
                      __html: `${pageText[7]}`,
                    }}
                  />
                </TaskListItemMiddle>
                <TaskListItemRight>
                  <ChevronImage
                    src={`/images/profile/icon-cv-${phoneState}.svg`}
                    alt={'info'}
                  />
                </TaskListItemRight>
              </TaskListItem>
            </TaskListItemLink>
          </TaskListBox>
        </TaskListBoxContainer>
      )
    }
  }

  const PromoPanel = (props) => {
    var bodyText1 = ''
    var buttonText = ''
    var buttonAction = ''
    var emailVerification = false

    if (queryParams.get('emv') === 'y') {
      emailVerification = true
      gaEvents.eventGeneric(
        'form_submit',
        'submitted',
        'Email verification completed'
      )
    }

    switch (promoPanelStep) {
      case progressSteps.email:
        bodyText1 = `${pageText[9]}`
        buttonText = `${pageText[10]}`
        buttonAction = progressSteps.email
        break
      case progressSteps.emailconf:
        bodyText1 = `${pageText[11]}`
        buttonText = `${pageText[12]}`
        buttonAction = chosen
        break
      case progressSteps.profile:
        bodyText1 = `${emailVerification ? pageText[11] + ' ' : ''}${
          pageText[13]
        }`
        buttonText = `${pageText[14]}`
        buttonAction = progressSteps.profile
        break
      case progressSteps.fee:
        bodyText1 = `${pageText[15]}`
        buttonText = `${pageText[17]}`
        buttonAction = progressSteps.fee
        break
      case progressSteps.id:
        bodyText1 = `${pageText[18]}`
        buttonText = `${pageText[19]}`
        buttonAction = progressSteps.id
        break
      case progressSteps.phone:
        /*
        if (props.status === 'approvedfinal') {
          bodyText1 = `${pageText[26]}`
        } else {
          bodyText1 = `${pageText[30]}`
        }
        */
        bodyText1 = `${pageText[26]}`
        buttonText = `${pageText[27]}`
        buttonAction = progressSteps.phone
        break
      case progressSteps.profilestage2:
        if (props.status === 'approvedfinal') {
          bodyText1 = `${pageText[28]}`
        } else {
          if (!profileEnhanced) {
            bodyText1 = `${pageText[30]}`
          } else {
            bodyText1 = `${pageText[55]}`
          }
        }
        buttonText = `${pageText[19]}`
        buttonAction = progressSteps.profilestage2
        break
      default:
        bodyText1 = `${emailVerification ? pageText[11] + ' ' : ''}${
          pageText[20]
        }`
        buttonText = `${pageText[21]}`
        buttonAction = progressSteps.photo
        break
    }
    return (
      <PromoPanelBox>
        <PromoPanelBody>
          <PromoText>
            <Subtitle
              color="#fff"
              size="24px"
              sizemd="22px"
              sizesm="21px"
              weight="400"
              margin="30px 20px 0 20px"
              dangerouslySetInnerHTML={{
                __html: `${bodyText1}`,
              }}
            />
            {promoPanelStep !== progressSteps.id && !profileEnhanced && (
              <ActionButtonMyFreebird
                type="submit"
                padding="10px 60px"
                margin="40px 20px 0"
                fontsizesm="16px"
                onClick={(e) => handlePromoPanelClick(e)}
              >
                {buttonText}
              </ActionButtonMyFreebird>
            )}
            {promoPanelStep === progressSteps.id && (
              <ActionButtonMyFreebird
                type="submit"
                padding="10px 60px"
                margin="40px 20px 0"
                fontsizesm="16px"
                onClick={(e) => handlePromoPanelClick(e)}
              >
                {pageText[45]}
              </ActionButtonMyFreebird>
            )}
          </PromoText>
        </PromoPanelBody>
      </PromoPanelBox>
    )
  }

  const TopPanel = () => {
    if (!profileEnhanced || props.auth.user.status !== 'approvedfinal') {
      return (
        <FlexRowProgress
          minheight={props.auth.user.phoneStatus === 'pending' && '416px'}
        >
          {' '}
          <PromoPanelMobileWrapper>
            <PromoPanel
              currency={currencySign}
              step={promoPanelStep}
              status={props.auth.user.status}
            />
          </PromoPanelMobileWrapper>
          <PromoPanelLaptopWrapper>
            <PromoPanel
              currency={currencySign}
              step={promoPanelStep}
              status={props.auth.user.status}
            />
          </PromoPanelLaptopWrapper>
          {accountStatus !== 'registered' ? (
            <TaskListApproved u={user} />
          ) : (
            <TaskList u={user} />
          )}
        </FlexRowProgress>
      )
    }
  }

  if (pageText.length === 0 || !currencySign || !props.auth.user) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[22]}</span>
        </div>
      </div>
    )
  }

  return (
    <MyFreebirdSection>
      {' '}
      <TopSectionContainer>
        <TopPanel />
        <OnboardingWrapper ref={actionRef}>
          <MyFreebirdOnboarding
            actionRef={actionRef}
            data={props}
            pageText={pageText}
            user={user}
            step={chosenStep}
            discountCode={discountCode}
            countriesNice={countriesNice}
            onboardingOpen={onboardingOpen}
            onUpdate={panelHasUpdated}
            onClose={closeOnboardingPanel}
            isCopied={isCopied}
            iAminSubscriptionFormPanel={iAminSubscriptionFormPanel}
            setIAminSubscriptionFormPanel={setIAminSubscriptionFormPanel}
            isCopiedInSubFormPanel={isCopiedInSubFormPanel}
            setIsCopiedInSubFormPanel={setIsCopiedInSubFormPanel}
            setShowPopup={setIsPopupVisible}
            setClickedFeeLink={setClickedFeeLink}
          />
        </OnboardingWrapper>
        <MyFreebirdProfilePanel
          pageText={pageText}
          user={user}
          country={country}
          profileEnhanced={profileEnhanced}
          onUpdate={handleTaskItemClick}
        />
      </TopSectionContainer>
      <MyFreebirdNavBar user={user} promoPanelStep={promoPanelStep} />
      <MainSectionContainer>
        <MyFreebirdPopup
          pageText={pageText}
          user={user}
          isIntersecting={isIntersecting}
          onUpdate={setPopupClosed}
        />
        <MyFreebirdOpacityScreen user={user} isIntersecting={isIntersecting} />

        <MyFreebirdOpacityDiscountScreen
          setShowPopup={setIsPopupVisible}
          isVisible={isPopupVisible}
        />
        <MyFreebirdDiscountPopup
          pageText={pageText}
          popTitle={pageText[56]}
          popText={pageText[57]}
          user={user}
          discountCode={discountCode}
          clickedFeeLink={clickedFeeLink}
          showPopup={isPopupVisible}
          setShowPopup={setIsPopupVisible}
          setIsCopied={setIsCopied}
          iAminSubscriptionFormPanel={iAminSubscriptionFormPanel}
          setIsCopiedInSubFormPanel={setIsCopiedInSubFormPanel}
        />

        <MyFreebirdDashboard
          pageText={pageText}
          user={user}
          stage1Achieved={stage1Achieved}
          messageTrigger={setIsIntersecting}
        />
      </MainSectionContainer>
    </MyFreebirdSection>
  )
}

export default withRouter(withAuth(MyFreebird))
